import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { LoginService } from '../../services/login.service';
import { animations } from '../../tools/animations';
import { ValidateRun } from '../../tools/utils/run.validator';

@Component({
  selector: 'app-recuperar-codigo',
  templateUrl: './recuperar-codigo.component.html',
  styleUrls: ['./recuperar-codigo.component.css']
})
export class RecuperarCodigoComponent implements OnInit {

  public form: FormGroup;
  public loading: boolean = false;
  public submitted: boolean = false;
  public response = {};
  public codigoAcceso: string;
  public curso_id: number;
  public extranjero: boolean = false;

  constructor(
    private messageService: MessageService,
    private router: Router,
    private route: ActivatedRoute,
    private loginService: LoginService
  ) { 
    this.route.queryParams.forEach(params => {
     this.curso_id = params.curso_id;
     this.codigoAcceso = params.codigoAcceso; 
    });
  }

  regExpInput(pattern, event) {
    this.response = {};
    const maskSeperator = new RegExp(pattern, 'g');
    let result = maskSeperator.test(event.key); return result;
  } 

  ngOnInit(): void {

    
    this.form = new FormGroup({
      run: new FormControl('', [Validators.required, Validators.minLength(8), Validators.maxLength(12), ValidateRun]),
      nroPasaporte: new FormControl('', [])
    });
    
  }

  changeExtranjero(e){
    this.extranjero = e.checked;
    if(this.extranjero){
      this.form.controls['run'].clearValidators();
      this.form.controls['nroPasaporte'].setValidators([Validators.required, Validators.minLength(5), Validators.maxLength(50)]);
    }else{
      this.form.controls['nroPasaporte'].clearValidators();
      this.form.controls['run'].setValidators([Validators.required, Validators.minLength(8), Validators.maxLength(12), ValidateRun]);
    }
    this.form.controls['run'].updateValueAndValidity();
    this.form.controls['nroPasaporte'].updateValueAndValidity();
  }

  onSubmit() {

    this.submitted = true;
    this.loading = true;

    if( this.form.invalid && (this.form.pristine || this.form.dirty) ){
      this.form.markAllAsTouched();
      this.loading = false;
    }

    if( this.form.valid ) {

      this.loginService.recuperarCodigo(this.form.value.run.split('-')[0], this.form.value.nroPasaporte, this.extranjero).then(res => {
        this.response = res;       
        this.loading = false;
        this.submitted = false;
        this.form.disable();        
      })  
      
    }
  }

}
